module.exports = __webpack_public_path__ + "media/images/emoticons/bus-d5525235b7a95ec26f4a447e87dcbad7.gif";